import { withMockQueryClient } from '../../stories/mockQueryClient';
import { iimReviewKeys } from '../../hooks/queryKeys';
import TechnicianRow from './index';
const MOCK_CONTEXT = {
    this_inspection: { duration_minutes: 95, custom_rule_findings_count: 0, featured_rule_finding: null },
    trend: {
        window_description: 'Last 12 inspections',
        inspections: [
            { inspection_id: 1, date: '2026-09-18', duration_minutes: 95, frequency: 'Annual' },
            { inspection_id: 2, date: '2026-08-15', duration_minutes: 82, frequency: 'Annual' }
        ],
        custom_rule_findings_count: 0,
        previous_inspections_count: 1,
        featured_rule_finding_trend: null
    },
    benchmarks: {
        building_average_duration_minutes: 78,
        building_median_duration_minutes: 85,
        building_median_rule_findings_per_inspection: 1
    }
};
const meta = {
    title: 'Features/IIMReview/TechnicianRow',
    component: TechnicianRow,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        withMockQueryClient([
            { queryKey: iimReviewKeys.techPerformanceContext(42, 1), scenario: { status: 'success', data: MOCK_CONTEXT } },
            { queryKey: iimReviewKeys.techPerformanceContext(43, 1), scenario: { status: 'success', data: MOCK_CONTEXT } }
        ])
    ],
    args: {
        inspectionId: 1,
        onSeeScorecard: () => undefined,
        technicianAssessment: {
            id: 101,
            inspectionId: 1,
            technicianId: 42,
            technicianName: 'Jane Smith',
            rating: 'needs_review',
            score: 62,
            summary: null,
            descriptionMd: null,
            status: 'detected',
            completedAt: null,
            generatedAt: '2026-09-18T10:00:00Z'
        }
    }
};
export default meta;
export const NeedsReview = {};
export const NeedsCoaching = {
    args: {
        technicianAssessment: {
            id: 102,
            inspectionId: 1,
            technicianId: 43,
            technicianName: 'Bob Johnson',
            rating: 'needs_coaching',
            score: 38,
            summary: null,
            descriptionMd: null,
            status: 'detected',
            completedAt: null,
            generatedAt: '2026-09-18T10:00:00Z'
        }
    }
};
